import Vue from "vue";
import App from "./App.vue";
import IdleVue from "idle-vue";
import router from "./Router/";
import vuetify from "./plugins/vuetify";
import store from "./store/index";
import Loading from "./components/Loading";
import ServerMessage from "./components/ServerMessage";
import VueTypedJs from "vue-typed-js";
import Auth from "../src/middleware/";
import VueMeta from "vue-meta";

Vue.config.productionTip = false;
Vue.use(VueMeta, {
  // optional pluginOptions
  refreshOnceOnNavigation: true,
});
Vue.component("Loading", Loading);
Vue.use(VueTypedJs);
Vue.component("ServerMessage", ServerMessage);

const eventsHub = new Vue();

Vue.use(IdleVue, {
  eventEmitter: eventsHub,
  store,
  idleTime: 600000, // 3 seconds,
  startAtIdle: false,
});

Vue.use(Auth);
router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.forVisitors)) {
    if (store.getters.getUser) {
      next({
        path: "/",
      });
    } else next();
  } else if (to.matched.some((record) => record.meta.forAuth)) {
    if (!store.getters.getUser) {
      next({
        path: "/login",
        query: { redirect: to.path },
      });
    } else next();
  } else next();
});

new Vue({
  vuetify,
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
